import React from 'react';
import { MemberType } from '@modules/client';
import {
  SvgIconProperty,
  SvgIconMethod,
  SvgIconEvent,
} from '@modules/ui/icons/EngineReferenceIcons';

export default function getReferenceMemberIcon(memberType: MemberType) {
  switch (memberType) {
    case MemberType.Property:
      return <SvgIconProperty />;
    case MemberType.Callback:
    case MemberType.Function:
    case MemberType.Method:
      return <SvgIconMethod />;
    case MemberType.Event:
      return <SvgIconEvent />;
    case MemberType.Constructor:
    case MemberType.MathOperation:
      return null; // Math operations don't have an icon
    default:
      return <SvgIconMethod />;
  }
}
